






























import { Emit, Prop, VModel, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import FileGeodeticService from "@/entities/file-geodetic/file-geodetic.service";

@Component
export default class FileRenameDialog extends Vue {
  @Prop() file;

  @VModel({ type: Boolean }) dialog: boolean;

  loading = false;
  newName = '';

  @Emit()
  onSuccess(newName) {}

  async renameFile() {
    let fileGeodeticService = new FileGeodeticService();
    try {
      await fileGeodeticService.partialUpdate({ id: this.file.id, fileName: this.newName });
      (this.$root as any).$bvToast.toast(`Đổi tên file thành công: ${this.newName}`, {
        toaster: 'b-toaster-top-center',
        title: 'Success',
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
      });
      this.onSuccess(this.newName);
    } catch (e) {
      (this.$root as any).$bvToast.toast(`Có lỗi xảy ra: ${e}`, {
        toaster: 'b-toaster-top-center',
        title: 'Lỗi',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    }
  }

  @Watch('dialog')
  onDialogChange(val, oldVal) {
    if (!val) {
      this.loading = false;
    } else {
      this.newName = this.file.fileName;
    }
  }
}
